import React, { useRef } from 'react';

const VIEW_LABELS = {
  eventos: 'Eventos',
  logistica: 'Logística',
  tareas: 'Tareas',
};

export default function AgendaFocusedView({ view, days, renderDay }) {
  const headerScrollRef = useRef(null);
  const section = VIEW_LABELS[view] || 'Agenda';
  const rowLabel = view === 'logistica' ? 'Logística' : section.slice(0, -1) || section;

  const syncHeader = scrollLeft => {
    if (headerScrollRef.current) headerScrollRef.current.scrollLeft = scrollLeft;
  };

  return (
    <section className="agenda-focused-view" aria-label={`Agenda: ${section}`}>
      <div className="agenda-focused-column-header">
        <div className="agenda-focused-column-scroll" ref={headerScrollRef}>
          <div className="column-strip agenda-focused-column-strip">
            <span>Orden</span>
            <span>{rowLabel}</span>
            <span className="col-center">Horarios</span>
            <span className="col-center">Armado</span>
            <span className="col-center">Operación</span>
            <span className="col-center">Desarmado</span>
            <span>Notas</span>
            <span />
          </div>
        </div>
      </div>

      <div className="agenda-focused-days">
        {days.map(date => renderDay(date, { onHorizontalScroll: syncHeader }))}
      </div>
    </section>
  );
}
